import { all, put } from "redux-saga/effects";
import * as CHANGE_TYPES from "../changDevice/type"

export function* changDeviceCurrentAction({ payload }: any): any {
  try {
    if (payload?.callCheck) {
      return;
    }
    yield all([
      put({
        type: CHANGE_TYPES.CHANGE_DEVICE_CURRENT_SUCCESS,
        payload: payload,
      }),
    ]);
  } catch (error: any) {
    const responseError = error?.response?.data?.error;
    const responseStatus = error?.response?.status || 400;
    yield all([
      put({
        type: CHANGE_TYPES.CHANGE_DEVICE_CURRENT_FAIL,
        payload: {
          message: responseError,
          status: responseStatus,
        },
      }),
    ]);
  }
}

export function* changDeviceCurrentActionDelete({ payload }: any): any {
  try {
    if (payload?.callCheck) {
      return;
    }
    yield all([
      put({
        type: CHANGE_TYPES.CHANGE_DEVICE_DELETE_SUCCESS,
        payload: payload,
      }),
    ]);
  } catch (error: any) {
    const responseError = error?.response?.data?.error;
    const responseStatus = error?.response?.status || 400;
    yield all([
      put({
        type: CHANGE_TYPES.CHANGE_DEVICE_CURRENT_FAIL,
        payload: {
          message: responseError,
          status: responseStatus,
        },
      }),
    ]);
  }
}

